import { PublicOrderClient } from '@src/orders/services/PublicOrderClient';
import { useQuery } from '@tanstack/react-query';

export const useGetPublicOrder = (token: string) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['publicPortal', token],
    queryFn: async () => await PublicOrderClient.getByToken(token),
  });

  return {
    data,
    isLoading,
    isError,
  };
};
